<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<section class="delivery container-fluid">
    <div class="delivery__content d-flex flex-column px-5 py-4">
        <div class="delivery__content__status">
            <p class="delivery__content__status__text">
                {{
                    'fe_details_step5_delivery_status_delivery_content_status_text'
                        | translate
                }}
            </p>
        </div>
        <div
            class="delivery__content__row d-flex flex-row align-items-center my-1"
        >
            <img
                class="delivery__content__row__icon"
                [src]="
                    (reservationDetails?.data?.reservationDetails?.precheckin
                        ? 'images/precheckin-check.svg'
                        : 'images/checkDeny.svg'
                    ) | cdn
                "
                alt="Check deny"
            />
            <h2 class="delivery__content__row__title">Pre Check-In</h2>
            <a
                *ngIf="
                    !reservationDetails?.data?.reservationDetails?.precheckin
                "
                class="delivery__content__row__inactive"
                [routerLink]="'pre-check-in' | formatUrl"
                >{{
                    'fe_details_step5_delivery_status_delivery_content_row_active'
                        | translate
                }}</a
            >
            <span
                *ngIf="reservationDetails?.data?.reservationDetails?.precheckin"
                class="delivery__content__row__active"
            >
                {{
                    'fe_details_step5_delivery_status_delivery_content_row_active_true'
                        | translate
                }}
            </span>
        </div>
        <p class="delivery__content__info">
            {{
                'fe_details_step5_delivery_status_delivery_content_info'
                    | translate
            }}
        </p>
        <div class="delivery__content__additional mt-1">
            <span
                (click)="swal()"
                class="delivery__content__additional__text"
                >{{
                    'fe_details_step5_delivery_status_delivery_content_additional'
                        | translate
                }}</span
            >
        </div>
        <fe-button
            *ngIf="
                !reservationDetails?.data?.reservationDetails?.precheckin &&
                !cancelationResponse?.data?.cancelationDate &&
                !reservationDetails?.data?.reservationDetails?.cancelationDate
            "
            [routerLink]="'pre-check-in' | formatUrl"
            [disabled]="configuration.featuresFlags.value?.precheckin !== true"
            class="mt-4"
            >{{
                'fe_details_step5_delivery_status_delivery_content_button'
                    | translate
            }}</fe-button
        >
    </div>
</section>

<ng-template #precheckTemplate>
    <div class="precheck container-fluid">
        <h2 class="precheck__title">
            {{ 'fe_details_step5_precheck_template_title' | translate }}
        </h2>
        <p class="precheck__description">
            {{ 'fe_details_step5_precheck_template_description' | translate }}
        </p>
        <ul class="precheck__list">
            <li>{{ 'fe_details_step5_precheck_template_li_1' | translate }}</li>
            <li>{{ 'fe_details_step5_precheck_template_li_2' | translate }}</li>
            <li>{{ 'fe_details_step5_precheck_template_li_3' | translate }}</li>
        </ul>
    </div>
</ng-template>
